import { Component, h, Event, EventEmitter } from '@stencil/core';


@Component({
    tag: 'kdx-menu-overlay',
    styleUrl: 'kdx-menu-overlay.scss',
    shadow: false
})
export class AppMenuOverlay {

    @Event() mobileOverlayClicked: EventEmitter;

    render() {
        return (
            <div class="mobile-menu-overlay" onClick={() => {this.mobileOverlayClicked.emit()}}></div>
        );
    }
}
